export default __webpack_public_path__ + "fk-cp-zion/img/no-chats_0e0d4f.svg";